module.exports = __webpack_public_path__ + "img/horizontal_7_6_9005.4157aec1.png";